import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgendaToggleService {
  isFlaggedAgenda = new BehaviorSubject<boolean>(false);
  isNormalAgenda = new BehaviorSubject<boolean>(true);
  calendarInitSubject = new Subject<any>();

  constructor() {
    this.newFlagedValue(false);
    this.newNormalValue(true);
  }

  newFlagedValue(value: boolean): void {
    this.isFlaggedAgenda.next(value);
  }

  newNormalValue(value: boolean): void {
    this.isNormalAgenda.next(value);
  }
}
